import { render, staticRenderFns } from "./eod-availabilities.vue?vue&type=template&id=980c3cc4&scoped=true"
import script from "./eod-availabilities.vue?vue&type=script&lang=js"
export * from "./eod-availabilities.vue?vue&type=script&lang=js"
import style0 from "./eod-availabilities.vue?vue&type=style&index=0&id=980c3cc4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980c3cc4",
  null
  
)

export default component.exports